import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Card, CardContent, Button, Typography, Container, TextField, Alert, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const { authMode, login, loginRedirect } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const fromState = (location.state as any)?.from;
  const fromFull: string = fromState ? (fromState.pathname + (fromState.search || '')) : '/dashboard';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await login(email, password);
      navigate(fromFull, { replace: true });
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '100vh' }}>
        <Card sx={{ mt: 8, width: '100%', maxWidth: 420 }}>
          <CardContent sx={{ p: 4 }}>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Typography component="h1" variant="h4" gutterBottom>
                Jersey Colours
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {authMode === 'local' ? 'Sign in to your local development account' : 'Sign in with your AWS Cognito account'}
              </Typography>
            </Box>

            {authMode === 'local' ? (
              <Box component="form" onSubmit={handleSubmit}>
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isLoading}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isLoading}
                />
                <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={isLoading} startIcon={isLoading ? <CircularProgress size={20} /> : undefined}>
                  {isLoading ? 'Signing In...' : 'Sign In'}
                </Button>
              </Box>
            ) : (
              <Button fullWidth variant="contained" color="primary" size="large" onClick={() => loginRedirect(fromFull)}>
                Continue with AWS Cognito
              </Button>
            )}
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Login;
